import styled from 'styled-components'

import { barnesTheme } from '../../theme/barnesTheme'

export const IntroText = styled.p`
  font-family: ${barnesTheme.fonts.body};
  font-size: 12px;
  font-weight: ${barnesTheme.fontWeights.light};
  color: ${barnesTheme.colors.text};
  line-height: 1.6;
  text-align: justify;
  margin: 0 0 ${barnesTheme.spacing.smallGap} 0;

  @media print {
    font-family: ${barnesTheme.fonts.body} !important;
    font-size: 12px !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    color: ${barnesTheme.colors.text} !important;
    line-height: 1.6 !important;
    text-align: justify !important;
    margin: 0 0 ${barnesTheme.spacing.smallGap} 0 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const DestinationsSubtitle = styled.h3`
  font-family: ${barnesTheme.fonts.heading};
  font-size: 15px;
  font-weight: ${barnesTheme.fontWeights.bold};
  color: ${barnesTheme.colors.accent};
  margin: ${barnesTheme.spacing.contentGap} 0 ${barnesTheme.spacing.smallGap} 0;

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-size: 15px !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    color: ${barnesTheme.colors.accent} !important;
    margin: ${barnesTheme.spacing.contentGap} 0 ${barnesTheme.spacing.smallGap}
      0 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const SeparatorLine = styled.div`
  width: 100%;
  height: 1px;
  background: ${barnesTheme.colors.border};
  margin: ${barnesTheme.spacing.contentGap} 0;

  @media print {
    width: 100% !important;
    height: 1px !important;
    background: ${barnesTheme.colors.border} !important;
    margin: ${barnesTheme.spacing.contentGap} 0 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const BottomSection = styled.div`
  display: flex;
  gap: ${barnesTheme.spacing.sectionGap};
  margin-top: ${barnesTheme.spacing.smallGap};

  @media print {
    display: flex !important;
    gap: ${barnesTheme.spacing.sectionGap} !important;
    margin-top: ${barnesTheme.spacing.smallGap} !important;
  }
`

export const StatsColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${barnesTheme.spacing.smallGap};
  flex-shrink: 0;
  width: 280px;

  @media print {
    display: flex !important;
    flex-direction: column !important;
    gap: ${barnesTheme.spacing.smallGap} !important;
    flex-shrink: 0 !important;
    width: 280px !important;
  }
`

export const CardRedBar = styled.div`
  width: 30px;
  height: 3px;
  background: ${barnesTheme.colors.accent};
  margin-bottom: 12px;

  @media print {
    width: 30px !important;
    height: 3px !important;
    background: ${barnesTheme.colors.accent} !important;
    margin-bottom: 12px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const StatsTitle = styled.h3`
  font-family: ${barnesTheme.fonts.heading};
  font-size: 14px;
  font-weight: ${barnesTheme.fontWeights.bold};
  color: ${barnesTheme.colors.primary};
  letter-spacing: 0.5px;
  margin: 0 0 8px 0;

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-size: 14px !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    color: ${barnesTheme.colors.primary} !important;
    letter-spacing: 0.5px !important;
    margin: 0 0 8px 0 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const StatItem = styled.div`
  display: flex;
  align-items: baseline;
  gap: 4px;
  flex-wrap: nowrap;
  line-height: 1.4;

  @media print {
    display: flex !important;
    align-items: baseline !important;
    gap: 4px !important;
    flex-wrap: nowrap !important;
    line-height: 1.4 !important;
  }
`

export const StatNumber = styled.span`
  font-family: ${barnesTheme.fonts.heading};
  font-size: 14px;
  font-weight: ${barnesTheme.fontWeights.bold};
  color: ${barnesTheme.colors.accent};

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-size: 14px !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    color: ${barnesTheme.colors.accent} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const StatLabel = styled.span`
  font-family: ${barnesTheme.fonts.body};
  font-size: 12px;
  font-weight: ${barnesTheme.fontWeights.light};
  color: ${barnesTheme.colors.text};

  @media print {
    font-family: ${barnesTheme.fonts.body} !important;
    font-size: 12px !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    color: ${barnesTheme.colors.text} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const MapColumn = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  @media print {
    flex: 1 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
`

export const MapImage = styled.img`
  width: 100%;
  height: auto;
  object-fit: contain;

  @media print {
    width: 100% !important;
    height: auto !important;
    object-fit: contain !important;
  }
`

export const MapPlaceholder = styled.div`
  width: 100%;
  height: 200px;
  background: ${barnesTheme.colors.grege};
  display: flex;
  align-items: center;
  justify-content: center;

  @media print {
    width: 100% !important;
    height: 200px !important;
    background: ${barnesTheme.colors.grege} !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const MapLabel = styled.span`
  font-family: ${barnesTheme.fonts.body};
  font-size: ${barnesTheme.fontSizes.small};
  font-weight: ${barnesTheme.fontWeights.light};
  color: ${barnesTheme.colors.textLight};

  @media print {
    font-family: ${barnesTheme.fonts.body} !important;
    font-size: ${barnesTheme.fontSizes.small} !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    color: ${barnesTheme.colors.textLight} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`
